import ResourceModule from './resource';
import CampaignTargetingsConstants
  from "../services/campaignTargetingsConstants";
import { normalizeAutoGoalsOptimizationFields } from '../common/util/validation-util';

const daysOfWeek = _.range(1,8);
function defaultDayPart(day, hourValue) {
  const hours = _.reduce(_.range(24), function(result, key) {
    result[key] = hourValue
    return result
  }, {});

  return {...hours, day: day};
}

function deserializeCampaign(data, campaignTargetingsConstants) {
  if (data.inherit_data_from_campaign_id === null) {
    data.inherit_data_from_campaign_id = -2;
  }

  if (data.autopilot_launcher_message !== null) {
    data.autopilot_launcher_state = 'on_hold';
  } else if (data.autopilot_launcher) {
    data.autopilot_launcher_state = 'active';
  } else {
    data.autopilot_launcher_state = 'inactive';
  }

  _.keys(data.urls).forEach(platform => {
    data['url_' + platform] = data.urls[platform];
  });

  if (data.status == 'paused') {
    data.start_mode = (data.start_date) ? 'specific_date' : 'dont_start';
  } else {
    data.start_mode = 'specific_date';
  }
  data.start_date = moment.utc(data.start_date || undefined).toDate();
  if (data.end_date) {
    data.end_mode = 'specific_date';
  } else {
    data.end_mode = 'never';
  }
  data.end_date = moment.utc(data.end_date || undefined).toDate();
  if(data.impression_attribution_percentage) {
    data.impression_attribution_percentage *= 100;
  }
  if(data.success_metric_external_event) {
    data.success_metric_external_event = data.success_metric_external_event.split(',');
  }

  var lookalikeBundles = _.chain(data.lookalike_bundles).map(t => t.bundle).values().value();

  var countries = _.chain(data.targetings).filter(t => t.property_key === "CountryCode").map(t => t.property_value).values().value();
  var ssps = _.chain(data.targetings).filter(t => t.property_key === "Ssp").map(t => t.property_value).values().value();
  var sspChannels = _.chain(data.targetings).filter(t => t.property_key === "SspChannel").map(t => t.property_value).values().value();
  var deviceOsList = _.chain(data.targetings).filter(t => t.property_key === "DeviceOs").map(t => t.property_value).values().value();
  var deviceOs = deviceOsList.length > 1 ? 'all' : deviceOsList[0];
  var bundleIds = _.chain(data.targetings).filter(t => t.property_key === "Bundle").map(t => t.property_value).values().value();
  var deviceModels = _.chain(data.targetings).filter(t => t.property_key === "DeviceModel").map(t => t.property_value).values().value();
  var connectionTypeList = _.chain(data.targetings).filter(t => t.property_key === "ConnectionType").map(t => t.property_value).values().value();
  var connectionType = connectionTypeList.length === 0 ? 'all' : connectionTypeList[0];
  var cities = _.chain(data.targetings).filter(t => t.property_key === "City").map(t => t.property_value).values().value();
  var trimmedCities = [...cities.slice(0, 99), '...'];
  var regions = _.chain(data.targetings).filter(t => t.property_key === "Region").map(t => t.property_value).values().value();
  var deviceOsVersion = _.chain(data.targetings).filter(t => t.property_key === "DeviceOsVersion").map(t => t.property_value).values().value();
  var deviceTypes = _.chain(data.targetings).filter(t => t.property_key === "DeviceType").map(t => t.property_value).values().value();
  var deviceIdTypeList = _.chain(data.targetings).filter(t => t.property_key === "DeviceIdType").map(t => t.property_value).values().value();
  var deviceIdType = deviceIdTypeList.length === 0 ? 'all' : deviceIdTypeList[0];
  var dayParts = _.chain(data.targetings).filter(t => t.property_key === "DayPart").map(t => t.property_value).values().value();
  let metros = _.chain(data.targetings).filter(t => t.property_key === "Metro").map(t => t.property_value).values().value();

  var countriesExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "CountryCode").map(t => t.exclude).value().shift() === true;
  var citiesExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "City").map(t => t.exclude).value().shift() === true;
  var regionsExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "Region").map(t => t.exclude).value().shift() === true;
  var deviceOsVersionExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "DeviceOsVersion").map(t => t.exclude).value().shift() === true;
  var sspExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "Ssp").map(t => t.exclude).value().shift() === true;
  var sspChannelsExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "SspChannel").map(t => t.exclude).value().shift() === true;
  var bundleExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "Bundle").map(t => t.exclude).value().shift() === true;
  var deviceModelsExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "DeviceModel").map(t => t.exclude).value().shift() === true;
  let metrosExclude = _.chain(data.targeting_groups).filter(t => t.property_key === "Metro").map(t => t.exclude).value().shift() === true;

  let dayPartsValues = [];
  if (_.isEmpty(dayParts)) {
    dayPartsValues = _.map(daysOfWeek, day => defaultDayPart(day, true))
  } else {
    const res =
        _.chain(dayParts)
            .map(dayHour => {
              const dayAndHour = dayHour.split('_');
              return {day: parseInt(dayAndHour[0]), hour: parseInt(dayAndHour[1])}
            })
            .reduce((result, value, key) => {
              result[value.day] = result[value.day] || [];
              result[value.day].push({[value.hour]: true});
              return result
            }, {})
            .map((values, key) => _.merge({day: parseInt(key)},...values))
            .value();
    const defaultFalseValues =
        _.chain(daysOfWeek)
            .map(day => {
              if (!_.find(res, dp => dp.day === day)) {
                return defaultDayPart(day, false);
              } else return {}
            })
            .filter(dp => !_.isEmpty(dp))
            .value()

    dayPartsValues = [...res, ...defaultFalseValues];
  }

  data.targetings = {
    countries: countries,
    deviceOs: deviceOs,
    ssps: ssps,
    sspChannels: sspChannels,
    bundleIds: bundleIds,
    deviceModels,
    connectionType,
    cities: cities,
    trimmedCities: trimmedCities,
    regions: regions,
    deviceOsVersion: deviceOsVersion,
    deviceTypes: deviceTypes,
    deviceIdType: deviceIdType,
    dayParts: _.sortBy(dayPartsValues, dp => dp.day),
    metros: metros,
  };

  data.targeting_groups = {
    countries: countriesExclude,
    deviceOsVersion: deviceOsVersionExclude,
    ssps: sspExclude,
    sspChannels: sspChannelsExclude,
    bundleIds: bundleExclude,
    deviceModels: deviceModelsExclude,
    cities: citiesExclude,
    regions: regionsExclude,
    metros: metrosExclude,
  };

  data.frequency_caps = campaignTargetingsConstants.transformFrequencyCaps(data);

  if (bundleIds.length > 0) {
    if (data.targeting_groups.bundleIds) {
      data.targetings.bundleIdsListType = 'policy_filter_blacklist';
    } else {
      data.targetings.bundleIdsListType = 'policy_filter_whitelist';
    }
    data.targetings.bundleIdsFileExist = true;
  } else {
    data.targetings.bundleIdsListType = 'policy_filter_none';
    data.targetings.bundleIdsFileExist = false;
  }

  if (deviceModels.length > 0) {
    if (data.targeting_groups.deviceModels) {
      data.targetings.deviceModelsListType = 'policy_filter_blacklist';
    } else {
      data.targetings.deviceModelsListType = 'policy_filter_whitelist';
    }
    data.targetings.deviceModelsFileExist = true;
  } else {
    data.targetings.deviceModelsListType = 'policy_filter_none';
    data.targetings.deviceModelsFileExist = false;
  }
  data.lookalike_bundles = lookalikeBundles.join('\n');

  if (!_.isEmpty(data.click_lookback_window_app_open_time_unit)) {
    if (data.click_lookback_window_app_open_time_unit === 'Minutes') {
      data.click_lookback_window_app_open_time_unit = 0;
    } else if (data.click_lookback_window_app_open_time_unit === 'Hours') {
      data.click_lookback_window_app_open_time_unit = 1;
    } else if (data.click_lookback_window_app_open_time_unit === 'Days') {
      data.click_lookback_window_app_open_time_unit = 2;
    }
  }

  if (!_.isEmpty(data.impression_lookback_window_app_open_time_unit)) {
    if (data.impression_lookback_window_app_open_time_unit === 'Minutes') {
      data.impression_lookback_window_app_open_time_unit = 0;
    } else if (data.impression_lookback_window_app_open_time_unit === 'Hours') {
      data.impression_lookback_window_app_open_time_unit = 1;
    } else if (data.impression_lookback_window_app_open_time_unit === 'Days') {
      data.impression_lookback_window_app_open_time_unit = 2;
    }
  }

  data.targetings.metrosFileExist = metros.length > 0;

  normalizeAutoGoalsOptimizationFields(data);

  return data;
}

function serializeCampaign(data, campaignTargetingsConstants) {
  data = _.cloneDeep(data);

  data.urls = {};
  delete data.url_global;
  angular.forEach(data, (value, key) => {
    if (/^url_/.test(key)) {
      data.urls[key.substring(4, key.length)] = value === null ? value : value.trim();
      delete data[key];
    }
  });

  if (data.inherit_data_from_campaign_id === -2) {
    data.inherit_data_from_campaign_id = null;
  }

  if (data.autopilot_launcher_state !== 'on_hold') {
    data.autopilot_launcher_message = null;
    data.autopilot_launcher_message_date = null;
    data.autopilot_launcher = (data.autopilot_launcher_state === 'active');
  }

  if (data.start_mode == 'immediate') {
    data.start_date = moment().format('YYYY-MM-DD HH:mm:ss');
  }
  data.start_date = moment(data.start_date).utc().format('YYYY-MM-DD HH:mm:ss');
  if (data.start_mode == 'dont_start') {
    delete data.start_date;
  }
  if (data.end_mode == 'never') {
    delete data.end_date;
  } else {
    data.end_date = moment(data.end_date).utc().format('YYYY-MM-DD HH:mm:ss');
  }
  if(data.impression_attribution_percentage) {
    data.impression_attribution_percentage /= 100;
  }
  if(data.success_metric_external_event){
    data.success_metric_external_event = data.success_metric_external_event.join();
  }

  data.click_postback_android = _.isEmpty(data.click_postback_android) ? null : data.click_postback_android;
  data.click_engagement_postback_android = _.isEmpty(data.click_engagement_postback_android) ? null : data.click_engagement_postback_android;
  data.click_postback_ios = _.isEmpty(data.click_postback_ios) ? null : data.click_postback_ios;
  data.click_engagement_postback_ios = _.isEmpty(data.click_engagement_postback_ios) ? null : data.click_engagement_postback_ios;
  data.default_deep_link_android = _.isEmpty(data.default_deep_link_android) ? null : data.default_deep_link_android;
  data.default_deep_link_ios = _.isEmpty(data.default_deep_link_ios) ? null : data.default_deep_link_ios;
  data.impression_postback_android = _.isEmpty(data.impression_postback_android) ? null : data.impression_postback_android;
  data.impression_engagement_postback_android = _.isEmpty(data.impression_engagement_postback_android) ? null : data.impression_engagement_postback_android;
  data.impression_postback_ios = _.isEmpty(data.impression_postback_ios) ? null : data.impression_postback_ios;
  data.impression_engagement_postback_ios = _.isEmpty(data.impression_engagement_postback_ios) ? null : data.impression_engagement_postback_ios;
  data.video_complete_postback_android = _.isEmpty(data.video_complete_postback_android) ? null : data.video_complete_postback_android;
  data.video_complete_postback_ios = _.isEmpty(data.video_complete_postback_ios) ? null : data.video_complete_postback_ios;
  data.lookalike_bundles = (data.campaign_advertising_type !== "UserAcquisition" || _.isEmpty(data.lookalike_bundles)) ? [] : _.map(_.uniq(data.lookalike_bundles.split('\n')), b => ({campaign_id: data.id, bundle: b}));

  if (!_.isEmpty(data.click_lookback_window_app_open_time_unit)) {
    if (data.click_lookback_window_app_open_time_unit === 0) {
      data.click_lookback_window_app_open_time_unit = 'Minutes';
    } else if (data.click_lookback_window_app_open_time_unit === 1) {
      data.click_lookback_window_app_open_time_unit = 'Hours';
    } else if (data.click_lookback_window_app_open_time_unit === 2) {
      data.click_lookback_window_app_open_time_unit = 'Days';
    }
  }

  if (!_.isEmpty(data.impression_lookback_window_app_open_time_unit)) {
    if (data.impression_lookback_window_app_open_time_unit === 0) {
      data.impression_lookback_window_app_open_time_unit = 'Minutes';
    } else if (data.impression_lookback_window_app_open_time_unit === 1) {
      data.impression_lookback_window_app_open_time_unit = 'Hours';
    } else if (data.impression_lookback_window_app_open_time_unit === 2) {
      data.impression_lookback_window_app_open_time_unit = 'Days';
    }
  }

  let excludeResult = [];

  if (data.targetings){
    let result = [];
    if (data.targetings.countries) {
      result.push(_.map(data.targetings.countries, c => ({campaign_id: data.id, property_key: 'CountryCode', property_value: c})));
    }
    if (data.targetings.ssps) {
      result.push(_.map(data.targetings.ssps, s => ({campaign_id: data.id, property_key: 'Ssp', property_value: s})));
    }
    if (data.targetings.sspChannels && (!data.targeting_groups || !data.targeting_groups.ssps)) {
      result.push(_.map(data.targetings.sspChannels, s => ({campaign_id: data.id, property_key: 'SspChannel', property_value: s})));
    }
    if (data.targetings.cities) {
      result.push(_.map(data.targetings.cities, s => ({campaign_id: data.id, property_key: 'City', property_value: s})));
    }
    if (data.targetings.regions) {
      result.push(_.map(data.targetings.regions, s => ({campaign_id: data.id, property_key: 'Region', property_value: s})));
    }
    if (data.targetings.deviceOs) {
      if (data.targetings.deviceOs === 'all') {
        result.push({campaign_id: data.id, property_key: 'DeviceOs', property_value: 'Android'})
        result.push({campaign_id: data.id, property_key: 'DeviceOs', property_value: 'iOS'})
      } else {
        result.push({campaign_id: data.id, property_key: 'DeviceOs', property_value: data.targetings.deviceOs})
      }
    }
    if (data.targetings.deviceOsVersion) {
      result.push(_.map(data.targetings.deviceOsVersion, s => ({campaign_id: data.id, property_key: 'DeviceOsVersion', property_value: s})));
    }
    if (data.targetings.connectionType) {
      if (data.targetings.connectionType !== 'all') {
        result.push({campaign_id: data.id, property_key: 'ConnectionType', property_value: data.targetings.connectionType})
      }
    }
    if (data.targetings.bundleIdsListType === 'policy_filter_whitelist') {
      data.targetings.bundleIds = data.targetings.bundleIdsCsvContent || data.targetings.bundleIds;
      result.push(_.map(data.targetings.bundleIds, c => ({campaign_id: data.id, property_key: 'Bundle', property_value: c})));
    }
    if (data.targetings.bundleIdsListType === 'policy_filter_blacklist') {
      data.targetings.bundleIds = data.targetings.bundleIdsCsvContent || data.targetings.bundleIds;
      result.push(_.map(data.targetings.bundleIds, c => ({campaign_id: data.id, property_key: 'Bundle', property_value: c})));
      excludeResult.push(({campaign_id: data.id, property_key: 'Bundle', exclude: 1}));
    }
    if (data.targetings.deviceModelsListType === 'policy_filter_whitelist') {
      data.targetings.deviceModels = data.targetings.deviceModelsCsvContent || data.targetings.deviceModels;
      result.push(_.map(data.targetings.deviceModels, c => ({campaign_id: data.id, property_key: 'DeviceModel', property_value: c})));
    }
    if (data.targetings.deviceModelsListType === 'policy_filter_blacklist') {
      data.targetings.deviceModels = data.targetings.deviceModelsCsvContent || data.targetings.deviceModels;
      result.push(_.map(data.targetings.deviceModels, c => ({campaign_id: data.id, property_key: 'DeviceModel', property_value: c})));
      excludeResult.push(({campaign_id: data.id, property_key: 'DeviceModel', exclude: 1}));
    }
    if (data.targetings.deviceTypes) {
      result.push(_.map(data.targetings.deviceTypes, c => ({campaign_id: data.id, property_key: 'DeviceType', property_value: c})));
    }
    if (data.targetings.deviceIdType) {
      if (data.targetings.deviceIdType !== 'all') {
        result.push({campaign_id: data.id, property_key: 'DeviceIdType', property_value: data.targetings.deviceIdType})
      }
    }
    if (data.targetings.dayParts) {
      const dayParts =
          _.chain(data.targetings.dayParts)
              .map(dp => {
                const {day, $$hashKey, ...hoursValues} = dp
                return _.reduce(hoursValues, function(res, value, key) {
                  if(value) {
                    let hourFormat = key.toString().padStart(2, "0");
                    res.push({campaign_id: data.id, property_key: 'DayPart', property_value: `${day}_${hourFormat}`});
                  }
                  return res
                }, [])})
              .flatten()
              .value()
      if (dayParts.length !== (24*7)) {
        result.push(...dayParts)
      }
    }

    data.targetings.metros = data.targetings.metrosCsvContent || data.targetings.metros;
    if (data.targetings.metros) {
      result.push(_.map(data.targetings.metros, c => ({campaign_id: data.id, property_key: 'Metro', property_value: c})));
    }

    data.targetings = _.flatten(result);
  }

  if (data.targeting_groups){
    if (data.targeting_groups.countries) {
      excludeResult.push(({campaign_id: data.id, property_key: 'CountryCode', exclude: data.targeting_groups.countries}));
    }
    if (data.targeting_groups.ssps) {
      excludeResult.push(({campaign_id: data.id, property_key: 'Ssp', exclude: data.targeting_groups.ssps}));
    }
    if (data.targeting_groups.sspChannels) {
      excludeResult.push(({campaign_id: data.id, property_key: 'SspChannel', exclude: data.targeting_groups.sspChannels}));
    }
    if (data.targeting_groups.cities) {
      excludeResult.push(({campaign_id: data.id, property_key: 'City', exclude: data.targeting_groups.cities}));
    }
    if (data.targeting_groups.regions) {
      excludeResult.push(({campaign_id: data.id, property_key: 'Region', exclude: data.targeting_groups.regions}));
    }
    if (data.targeting_groups.deviceOsVersion) {
      excludeResult.push(({campaign_id: data.id, property_key: 'DeviceOsVersion', exclude: data.targeting_groups.deviceOsVersion}));
    }
    if (data.targeting_groups.metros !== undefined) {
      excludeResult.push(({campaign_id: data.id, property_key: 'Metro', exclude: data.targeting_groups.metros}));
    }

    data.targeting_groups = _.flatten(excludeResult);
  }

  if (data.frequency_caps) {
    const frequencyCapsArr = [];
    if (data.frequency_caps.rule) {
      const nonEmptyRules = _.chain(data.frequency_caps.rule)
          .filter(({interval_in_hours, times, ...rest}) => interval_in_hours !== null && times !== null)
          .map(({interval_in_hours, ...rest}) => ({interval_in_sec: _.round(interval_in_hours, 1) * 3600, ...rest}))
          .value();
      frequencyCapsArr.push(...nonEmptyRules);
    }
    if (data.frequency_caps.impression) {
      const nonEmptyRules = _.chain(data.frequency_caps.impression)
          .filter(({interval_in_hours, times, ...rest}) => interval_in_hours !== null && times !== null)
          .map(({interval_in_hours, ...rest}) => ({interval_in_sec: _.round(interval_in_hours, 1) * 3600, ...rest}))
          .value();
      frequencyCapsArr.push(...nonEmptyRules);
    }
    data.frequency_cap_rules = frequencyCapsArr;
  }

  delete data.connection_type;
  delete data.start_mode;
  delete data.end_mode;
  delete data.disabledOptions;
  delete data.currency;
  delete data.second_auction_bid;
  delete data.global_postback;
  delete data.platforms;
  delete data._segment_ids;
  normalizeAutoGoalsOptimizationFields(data);
  return data;
}

function deserializeGame(data) {
  if(data.success_metric_external_event) {
    data.success_metric_external_event = data.success_metric_external_event.split(',');
  }
  if (data.mmp === undefined) {
    data.mmp = { name: 'None', id: null }
  }
  if (data.gdpr_api_key || data.gdpr_email) {
    data.gdpr = true;
  }

  data.ctv_api_username = data.ctv ? data.ctv.api_username : undefined;
  data.ctv_api_password = data.ctv ? data.ctv.api_password : undefined;
  data.ctv_checkbox = !!data.ctv;

  return data;
}

function serializeGame(data) {
  if (data.external_id == '') {
    delete data.external_id;
  }
  if (data.override_game_developer_name == '') {
    data.override_game_developer_name = null;
  }
  if (data.advertiser_legal_entity_and_country == '') {
    data.advertiser_legal_entity_and_country = null;
  }
  if(data.game_success_metric !== 'game_event_progress') {
    data.success_metric_external_event = null;
  }
  if(data.success_metric_external_event){
    data.success_metric_external_event = data.success_metric_external_event.join();
  }
  if(data.mmp != undefined && data.mmp.id === null){
    data.mmp = null;
  }
  if (!data.gdpr) {
    data.gdpr_api_key = null;
    data.gdpr_email = null;
  }

  if (data.ctv_checkbox) {
    data.ctv = {
      api_username: data.ctv_api_username,
      api_password: data.ctv_api_password,
      game_id: data.id
    };
  } else {
    data.ctv = null;
    data.ctv_api_username = null;
    data.ctv_api_password = null;
  }

  return data;
}

export default angular.module('app.resources', [
  'restangular',
  ResourceModule.name,
  CampaignTargetingsConstants.name
])
.factory('CampaignsResource', function (Resource, campaignTargetingsConstants) {
  return Resource('campaigns', {
    deserialize: (data) => deserializeCampaign(data, campaignTargetingsConstants),
    serialize: (data) => serializeCampaign(data, campaignTargetingsConstants)
  });
})
.factory('CampaignsV4Resource', function (Resource, campaignTargetingsConstants) {
  return Resource('campaigns', {
    baseUrl: '/api/v4',
    deserialize: (data) => deserializeCampaign(data, campaignTargetingsConstants),
    serialize: (data) => serializeCampaign(data, campaignTargetingsConstants)
  });
})
.factory('CampaignAnalyticsResource', function (Resource) {
  return Resource('campaign-analytics');
})
.factory('BudgetAnalyticsResource', function (Resource) {
  return Resource('budget-analytics');
})
.factory('TargetingResource', function (Resource) {
  return Resource('targeting');
})
.factory('CohortsResource', function (Resource) {
  return Resource('cohort-analytics');
})
.factory('CampaignAnalyticsBreakdownResource', function (Resource) {
  return Resource('campaign-analytics/breakdown', {baseUrl: '/api/v2'});
})
.factory('CampaignsOverviewByGameResource', function (Resource) {
  return Resource('campaign-analytics/overview-campaigns-by-game-qb-with-roi', {baseUrl: '/api/v2'});
})
.factory('GameAnalyticsResource', function (Resource) {
  return Resource('game-analytics');
})
.factory('SegmentAnalyticsResource', function (Resource) {
  return Resource('segment-analytics');
})
.factory('SegmentAnalyticsBreakdownResource', function (Resource) {
  return Resource('segment-analytics/breakdown');
})
.factory('SegmentSizePreviewResource', function (Resource) {
  return Resource('segment-analytics/size_preview');
})
.factory('SegmentTlMatchedUsersSizePreviewResource', function (Resource) {
  return Resource('segment-analytics/tl_matched_users_size_preview');
})
.factory('SegmentMatchingSegmentSizePreviewResource', function (Resource) {
  return Resource('segment-analytics/matching_segment_size_preview');
})
.factory('SegmentTopCountriesPreviewResource', function (Resource) {
  return Resource('segment-analytics/top_countries_preview');
})
.factory('SegmentTopDevicesPreviewResource', function (Resource) {
  return Resource('segment-analytics/top_devices_preview');
})
.factory('ManualMaxBidPrices', function (Resource) {
  return Resource('max-bid-prices/manual');
})
.factory('MaxBidPricesCampaignBestMatch', function (Resource) {
  return Resource('max-bid-prices/campaign-best-match');
})
.factory('GameDevelopersResource', function (Resource) {
  return Resource('game-developers', {
    deserialize: function (data) {
      data.origCurrency = data.currency;
      data.agency_checkbox = !!data.agency;
      return data;
    },
    serialize: function (data) {
      delete data.origCurrency;
      if (!data.agency_checkbox) {
        data.agency = null;
      }
      delete data.agency_checkbox;
      return data;
    }
  });
})
.factory('AllGameDevelopersResource', function (Resource) {
  return Resource('game-developers/all');
})
.factory('FeesResource', function (Resource) {
  return Resource('fees');
})
.factory('UserAccessRequestsResource', function (Resource) {
  return Resource('user-access-requests');
})
.factory('BundlesResource', function (Resource) {
  return Resource('bundles');
})
.factory('UserExplorerResource', function (Resource) {
  return Resource('user-explorer');
})
.factory('UserExplorerUserGroupsResource', function (Resource) {
  return Resource('user-explorer/usergroups');
})
.factory('GamesResource', function (Restangular, Resource) {
  Restangular.extendModel('games', function (model) {
    model.getGameDeveloper = (() => Restangular.one('game-developers', model.game_developer_id).get());
    return model;
  });
  return Resource('games', {
    deserialize: deserializeGame,
    serialize: serializeGame,
  });
})
.factory('GamesV2Resource', function (Restangular, Resource) {
  Restangular.extendModel('games', function (model) {
    model.getGameDeveloper = (() => Restangular.one('game-developers', model.game_developer_id).get());
    return model;
  });
  return Resource('games', {
    baseUrl: '/api/v2',
    deserialize: (data) => {
      if (data.items) {
        data.items = data.items.map(item => deserializeGame(item));
      }
      return data
    },
    serialize: serializeGame,
  });
})
.factory('GamesLimitedResource', function (Restangular, Resource) {
  // Cached resource.
  Restangular.extendModel('games/limited', function (model) {
    model.getGameDeveloper = (() => Restangular.one('game-developers', model.game_developer_id).get());
    return model;
  });
  return Resource('games/limited', {
    cachingAtive: true,
    serialize: function (data) {
      if (data.external_id == '') {
        delete data.external_id;
      }
      return data;
    }
  });
})
.factory('GamesCountResource', function (Resource) {
  return Resource('games/count');
})
.factory('UsersResource', function (Resource, Restangular) {
  Restangular.extendModel('users', function (model) {
    model.hasRole = (role => {
      const wanted = _.isArray(role) ? role : [role];
      return _.intersection(model.roles, wanted).length > 0;
    });
    model.hasPermission = (permission => {
      if (_.isArray(permission)) {
        return _.intersection(model.permissions, permission).length > 0;
      }
      else {
        return _.includes(model.permissions, permission);
      }
    });
    return model;
  });
  return Resource('users', {
    deserialize: function (data) {
      if (data.game_developer_ids) {
        const agencyRoles = ['AGENCY', 'ADMIN_AGENCY', 'OPERATION_MANAGER'];
        if (_.isArray(data.roles) && !data.roles.some(role => agencyRoles.includes(role))) {
          data.game_developer_ids = data.game_developer_ids[0];
        }
      }

      if (data.roles) {
        data.role = data.roles[0];
      }

      data.permissions = data.permissions || [];
      return data;
    },
    serialize: function (data) {
      if (data.game_developer_ids && !_.isArray(data.game_developer_ids)) {
        data.game_developer_ids = [data.game_developer_ids];
      }
      if (data.role === 'GG_ACCOUNT_MANAGER' || data.role === 'ADMIN') {
        data.game_developer_ids = [];
      }

      if (data.approve_user === true) {
        data.status = 'Active';
      } else if (data.approve_user === false) {
        data.status = 'PendingApproval';
      }

      data.roles = [data.role];
      delete data.role;
      delete data.approve_user;
      delete data.permissions;
      delete data.reactivate_user;
      return data;
    }
  });
})
.factory('SegmentsResource', function (Resource) {
  return Resource('segments', {
    deserialize: function (data) {
      data.type = 'engagement';
      data.isCtv = data.ctv !== null;
      return data;
    },
    serialize: function (data) {
      const clonedData = _.clone(data);
      delete clonedData.type;
      delete clonedData.containerOffsetTop;
      delete clonedData.preview;
      if (!clonedData.isCtv) {
        clonedData.ctv = null;
      } else {
        clonedData.ctv = {
          segment_id: clonedData.id,
        };
      }
      return clonedData;
    }
  });
})
.factory('BannerPreviewResource', function (Restangular) {
  return Restangular.withConfig(function (RestangularConfigurer) {
    RestangularConfigurer.setBaseUrl('peso');
  }).service('personalization');
})
.factory('DynamicBannerPreviewResource', function (Restangular) {
  return Restangular.withConfig(function (RestangularConfigurer) {
    RestangularConfigurer.setBaseUrl('creative');
  }).service('preview');
})
.factory('MeResource', function (Restangular) {
  Restangular.extendModel('users/me', function (model) {
    model.hasRole = (role => {
      const wanted = _.isArray(role) ? role : [role];
      return _.intersection(model.roles, wanted).length > 0;
    });
    model.hasPermission = (permission => {
      if (_.isArray(permission)) {
        return _.intersection(model.permissions, permission).length > 0;
      }
      else {
        return _.includes(model.permissions, permission);
      }
    });
    model.save = (() => Restangular.one('users', model.id).customPUT(model.plain()));
    return model;
  });
  return Restangular.service('users/me');
})
.factory('SegmentPreviewResource', function () {
  return {
    sizeAlreadyLoadedOnce: false,
    total_size: -1,
    segment_size: -1,
    getText: ( number ) => {
      if ( !isNaN(number) && typeof number === 'number' ) {
        var abs = Math.abs( number );
        if ( abs >= Math.pow( 10, 12 ) ) {
          number = ( number / Math.pow( 10, 12 ) ).toFixed( 1 ) + "T";
        } else if ( abs < Math.pow( 10, 12 ) && abs >= Math.pow( 10, 9 ) ) {
          number = ( number / Math.pow( 10, 9 ) ).toFixed( 1 ) + "B";
        } else if ( abs < Math.pow( 10, 9 ) && abs >= Math.pow( 10, 6 ) ) {
          number = ( number / Math.pow( 10, 6 ) ).toFixed( 1 ) + "M";
        } else if ( abs < Math.pow( 10, 6 ) && abs >= Math.pow( 10, 3 ) ) {
          number = ( number / Math.pow( 10, 3 ) ).toFixed( 1 ) + "K";
        }
        return number + '<br><b>users<b>';
      } else {
        return '-<br><b>users<b>';
      }
    },
    loading: {
      size: true,
      topCountries: true,
      topDevices: true
    }
  };
})



/** WEBPACK FOOTER **
 ** ./src/resources/resources.js
 **/